import React from 'react';
import Container from '../common/container';
import Button from '../common/button';
import { ArrowRightIcon } from '~/svgs/home-page';
import Image from 'next/image';
import { NextLink, Translate, useTranslate } from '~/i18n';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { useCurrency } from '~/providers';
import { SliderArrowRight } from '~/svgs/common';
import cn from 'classnames';
const Trending = ({ data }: any) => {
   const { dir } = useTranslate();
   const { getConvertedPriceWithSymbol } = useCurrency();
   return (
      <section className="py-8 lg:py-16">
         <Container>
            <div className="">
               <div className="w-fit relative mb-2">
                  <div className="flex flex-col w-full ">
                     <div className=" text-[#727272] text-lg font-normal uppercase leading-none">
                        <Translate id="business:experinces title" />
                     </div>
                  </div>
               </div>
               <Swiper
                  key={`${dir}-trending`}
                  dir={dir}
                  noSwiping
                  slidesPerView="auto"
                  spaceBetween={60}
                  modules={[Navigation, Autoplay]}
                  navigation={{
                     prevEl: '.trending-prev',
                     nextEl: '.trending-next',
                  }}
                  autoHeight={true}
                  updateOnWindowResize={true}
                  autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}>
                  {data?.map((slide: any, index: any) => (
                     <SwiperSlide key={index} className="h-auto">
                        <div className="grid w-full h-full grid-cols-1 gap-8 overflow-hidden lg:grid-cols-2 lg:gap-x-16">
                           <div className="flex flex-col w-full ">
                              <div
                                 className="text-4xl font-normal text-black line-clamp-2"
                                 title={slide?.title}>
                                 {slide?.title}
                              </div>
                              <div className="block lg:hidden">
                                 <div className="relative mt-6 ml-auto aspect-[4/3] w-full">
                                    <Image
                                       src={slide?.src}
                                       className="object-cover rounded-2xl"
                                       fill
                                       alt={slide?.title}
                                    />
                                 </div>
                              </div>
                              <div className=" text-[#333333] text-base mt-6 font-primary line-clamp-6">
                                 {slide?.description}
                              </div>

                              <div className="mt-auto pt-5">
                                 <span className="text-[#333333] text-xl ">
                                    <Translate id="common:starts from" /> {'  '}
                                 </span>
                                 <span className="text-2xl font-normal text-madinah-primary">
                                    {getConvertedPriceWithSymbol(
                                       slide?.price_start_from || slide?.price
                                    )}
                                 </span>
                              </div>

                              <Button
                                 type="outline-primary"
                                 className="flex items-center gap-4 mt-4 w-fit group">
                                 <NextLink href={slide?.href} className="flex items-center gap-4">
                                    <Translate id="booking:book now" />
                                    <ArrowRightIcon className="ltr:ml-2 rtl:mr-2 rtl:rotate-180 group-hover:[&>g>path]:fill-white" />
                                 </NextLink>
                              </Button>
                           </div>
                           <div className="hidden lg:block">
                              <div className="aspect-[16/9] relative ml-auto w-full">
                                 <Image
                                    src={slide?.src}
                                    className="object-cover rounded-2xl"
                                    fill
                                    alt={slide?.title}
                                 />
                              </div>
                           </div>
                        </div>
                     </SwiperSlide>
                  ))}
               </Swiper>
            </div>
            <div className="w-full lg:w-1/2">
               <div className="flex items-center gap-2 mt-6">
                  <button
                     className={cn(
                        'swiper-arrow bg-white trending-prev focus:outline-none focus:ring-1 ring-primary-light primary'
                     )}
                     aria-label="previous">
                     {dir === 'rtl' ? (
                        <SliderArrowRight />
                     ) : (
                        <SliderArrowRight className="transform rotate-180" />
                     )}
                  </button>
                  <button
                     className={cn(
                        'swiper-arrow bg-white trending-next focus:outline-none focus:ring-1 ring-primary-light primary'
                     )}
                     aria-label="next">
                     {dir === 'rtl' ? (
                        <SliderArrowRight className="transform rotate-180" />
                     ) : (
                        <SliderArrowRight />
                     )}
                  </button>
               </div>
               <div className="inline-flex items-center justify-start w-full pt-8 mt-8 border-t border-black/10 ">
                  <NextLink
                     href="/search"
                     className="flex items-center gap-2 text-xl font-normal transition-all text-madinah-primary hover:opacity-80 hover:transition-all">
                     <Translate id="common:show all experiences" />
                     <div className="w-4 h-4">
                        <ArrowRightIcon className="w-4 h-4 rtl:rotate-180" />
                     </div>
                  </NextLink>
               </div>
            </div>
         </Container>
      </section>
   );
};

export default Trending;
